<script>
  import { pushMessage } from '../../../Api/api';

  export let channel;

  let title = '';
  let description = '';

  let sendingMsg = false;
  let msg = 'Sender melding, et lite øyeblikk...';

  const onPushMsgClicked = async () => {
    msg = 'Sender melding, et lite øyeblikk...';
    sendingMsg = true;
    await pushMessage({
      category: channel.category,
      channelId: channel.id,
      title,
      description,
    });
    title = '';
    description = '';
    setTimeout(() => {
      msg = 'Melding sent!';
      setTimeout(() => {
        sendingMsg = false;
      }, 2000);
    }, 1000);
  };
</script>

<div class="push-container">
  <h1>Send egendefinert push melding</h1>
  {#if !sendingMsg}
    <label for="msg-title">Tittel</label>
    <input id="msg-title" type="text" bind:value={title} />
    <label for="msg-description">Beskrivelse (valgfritt)</label>
    <input type="text" bind:value={description} />
    <button disabled={!channel || !title || sendingMsg} on:click={onPushMsgClicked}
      >Send melding</button
    >
  {:else}
    <p class="info">{msg}</p>
  {/if}
</div>

<style src="./customPushMsg.scss"></style>
